<template>
  <main-layout>
    <base-card
      class="d-md-flex row py-2 col-lg-10 career-cell__base-card header-favorites"
    >
      <div
        v-if="orderBy==='ranking'"
        class="career-cell__ranking header-favorites-stuff"
      >
        <span class="career-cell__ranking__number">{{ "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" }}</span>
      </div>
      <div
        class="career-cell"
        style="padding: 0px;"
      >
        <div class="col-12 col-lg-3">
          <label
            for=""
            class="form-control-label text-uppercase text-small mb-0"
          >Ordenar por</label>

          <select
            id=""
            v-model="orderBy"
            name=""
            class="form-control form-control-sm"
          >
            <option value="ranking">
              Mi ranking
            </option>
            <option value="salary">
              Salario Promedio
            </option>
            <option value="Lengua Española">
              Promedio en pruebas nacionales de Lengua Española
            </option>
            <option value="Matemáticas">
              Promedio en pruebas nacionales de Matemáticas
            </option>
            <option value="Ciencias Sociales">
              Promedio en pruebas nacionales de Ciencias Sociales
            </option>
            <option value="Ciencias Naturales">
              Promedio en pruebas nacionales de Ciencias Naturales
            </option>
          </select>
        </div>
        <div class="d-none d-lg-block col-lg-1 text-uppercase text-small">
          Salario Promedio
        </div>
        <div class="col-lg-7">
          <div class="row">
            <header-favorites-table
              id="tooltip-Lengua-no-ranking"
              title="Lengua Española"
            />
            <header-favorites-table
              id="tooltip-Matematicas-no-ranking"
              title="Matemáticas"
            />
            <header-favorites-table
              id="tooltip-Sociales-no-ranking"
              title="Ciencias Sociales"
            />
            <header-favorites-table
              id="tooltip-Naturales-no-ranking"
              title="Ciencias Naturales"
            />
          </div>
        </div>
        <div class="d-none d-lg-block col-lg-1 text-uppercase text-small career-cell__data ml-0" />
      </div>
      <div
        id="overlay"
        :style="`opacity: ${showOverlay ? '1': '0'}`"
      />
    </base-card>

    <div class="row">
      <!-- Main col -->
      <div class="col-lg-10">
        <template v-if="orderBy == 'ranking'">
          <loading :loading="loading_data" />
          <div v-if="!loading_data && !careers.length">
            <p>No has agregado favoritos, vuelve al explorador para agregar carreras favoritas.</p>
          </div>
          <draggable
            v-model="careers"
            handle=".career-cell__ranking__grip"
            @end="dragHandler"
          >
            <div
              v-for="(career, index) in careers"
              :key="index"
              :class="{overlay_class: showOverlayRow && index===0}"
            >
              <CareerCell
                :key="index + 1"
                :ranking="index + 1"
                :career="career"
                :add-university-overlay="showOverlayButton"
                :final-index="lengthCareers"
                :add-ranking-overlay="showOverlayRanking"
                @delete-favorite="openModalDeleteFavorite"
                @change-ranking="changeRanking"
              />
            </div>
          </draggable>
        </template>
        <template v-else>
          <div
            v-for="(career, index) in careers"
            :key="index"
          >
            <CareerCell
              :key="career.career_name"
              :career="career"
              @delete-favorite="openModalDeleteFavorite"
            />
          </div>
        </template>
      </div>
      <!-- Sidebar col -->
      <div class="col-lg-2 order-first order-lg-last">
        <HelpVideo
          src="vid/fav.mp4"
          img_placeholder="video-help.jpg"
          gif_preview="video-help.gif"
        />

        <base-card>
          <base-button
            inverse
            block
            :class="'mb-2 d-flex justify-content-between align-items-center px-3'+
              (sendingMail?' centerLoading':'')"
            :disabled="blockMailButton || careers.length < 1"
            @click="shareSummary"
          >
            <div v-if="!sendingMail">
              Enviar a mi <span class="text-nowrap">e-mail</span>
              <fa-icon
                class="ml-2"
                icon="envelope"
              />
            </div>
            <div class="d-flex align-items-center">
              <div
                v-if="sendingMail"
                class="spinner-border ml-auto"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </base-button>
        </base-card>
        <base-card>
          <img
            src="@/assets/img/reporte.png"
            class="w-100 d-none d-lg-inline"
          >
          <br>
          <p class="text-align-center">
            Hemos creado <br> este <b>reporte</b> para tí.
          </p>
          <base-button
            inverse
            block
            class="d-flex justify-content-between align-items-center px-3"
            :disabled="careers.length < 1"
            @click="downloadSummary"
          >
            Descargar <fa-icon icon="download" />
          </base-button>
        </base-card>
      </div>
    </div>
    <base-modal
      id="asdf"
      title="Eliminar carrera favorita"
      :show="modalDelete"
      size="sm"
      @closed="modalDelete = false"
    >
      <p>¿Estás seguro de querer eliminar esta carrera de tus favoritas?</p>
      <div class="row">
        <div class="col-6 text-left">
          <base-button @click="deleteFavorite()">
            Sí, eliminar
          </base-button>
        </div>
        <div class="col-6 text-right">
          <base-button
            :inverse="true"
            @click="modalDelete = false"
          >
            Cancelar
          </base-button>
        </div>
      </div>
    </base-modal>
    <base-modal
      id="ctrl"
      title="Mail Enviado"
      :show="sentMailModal"
      size="sm"
      @closed="closeSentModal"
    >
      <p>Hemos enviado el reporte a tu correo electrónico</p>
      <div class="row">
        <div class="col text-right">
          <base-button @click="sentMailModal = false">
            Cerrar
          </base-button>
        </div>
      </div>
    </base-modal>
  </main-layout>
</template>
<script>
import draggable from 'vuedraggable';
import CareerCell from './CareerCell.vue';
import HelpVideo from './HelpVideo.vue';
import { studentsService } from '../../_services';
import CONFIG from '../../config';
import { EventBus } from '../../components/EventBus';

export default {
    name: 'FavoritesIndex',
    components: {
        CareerCell,
        HelpVideo,
        draggable,
    },
    data() {
        return {
            student_overlay_row: false,
            student_overlay_button: false,
            student_overlay_ranking: false,
            showOverlay: false,
            showOverlayRow: false,
            showOverlayButton: false,
            showOverlayRanking: false,
            sendingMail: false,
            blockMailButton: false,
            loading_data: false,
            showUniversity: false,
            modalDelete: false,
            sentMailModal: false,
            orderBy: 'ranking',
            careers: [],
            careersByRanking: [],
            uuidToDelete: '',
        };
    },
    computed: {
        lengthCareers() {
            return this.careers.length;
        },
    },
    watch: {
        orderBy(newOrder, oldOrder) {
            if (newOrder === 'ranking') {
                this.careers = this.careersByRanking.slice();
            } else {
                if (oldOrder === 'ranking') {
                    this.careersByRanking = this.careers.slice();
                }
                let compareCareers;
                if (newOrder === 'salary') {
                    compareCareers = function (c1, c2) {
                        if (!c1.income) {
                            return -1;
                        } if (!c2.income) {
                            return 1;
                        }
                        return c2.income - c1.income;
                    };
                } else {
                    compareCareers = function (c1, c2) {
                        if (!c1.grades[newOrder]) {
                            return -1;
                        } if (!c2.grades[newOrder]) {
                            return 1;
                        }
                        return c2.grades[newOrder] - c1.grades[newOrder];
                    };
                }
                this.careers.sort(compareCareers);
            }
        },
    },
    mounted() {
        // this.student_overlay_row = this.$store
        // .getters['authentication/university_trigger']; -> Eliminado con potencial re-uso
        this.student_overlay_button = this.$store.getters['authentication/university_trigger'];
        this.student_overlay_ranking = this.$store.getters['authentication/ranking_trigger'];
        this.$nextTick(function () {
            this.getData();
        });
        // EventBus.$on('showOverlayRow', this.addOverlayRow);
        // EventBus.$on('closeOverlayRow', this.removeOverlayRow);
        // -> Eliminados con potencial re-uso
        EventBus.$on('showOverlayButton', this.addOverlayButton);
        EventBus.$on('closeOverlayButton', this.removeOverlayButton);
        EventBus.$on('showOverlayRanking', this.addOverlayRanking);
        EventBus.$on('closeOverlayRanking', this.removeOverlayRanking);
    },
    destroyed() {
        this.$store.dispatch('clippyNotifications/leaveFavorites');
    },
    methods: {
        addOverlayRanking() {
            if (this.student_overlay_ranking) {
                this.showOverlay = true;
                this.showOverlayRanking = true;
            }
        },
        removeOverlayRanking() {
            this.showOverlay = false;
            this.showOverlayRanking = false;
            if (this.student_overlay_ranking) {
                studentsService
                    .patchStudent(
                        this.$store.getters['authentication/student_uuid'],
                        { ranking_trigger: false },
                    ).then(() => {
                        this.$store.dispatch('authentication/triggeredRankingOverlay');
                    });
            }
        },
        addOverlayButton() {
            if (this.student_overlay_button) {
                this.showOverlay = true;
                this.showOverlayButton = true;
            }
        },
        removeOverlayButton() {
            this.showOverlay = false;
            this.showOverlayButton = false;
            if (this.student_overlay_button) {
                studentsService
                    .patchStudent(
                        this.$store.getters['authentication/student_uuid'],
                        { university_trigger: false },
                    ).then(() => {
                        this.$store.dispatch('authentication/triggeredUniversityOverlay');
                    });
            }
        }, /* -> Eliminado con potencial re-uso
        addOverlayRow() {
            if (this.student_overlay_row) {
                this.showOverlay = true;
                this.showOverlayRow = true;
            }
        },
        removeOverlayRow() {
            this.showOverlay = false;
            this.showOverlayRow = false;
            if (this.student_overlay_row) {
                // PATCH student info to make trigger false
                return null;
            }
        }, */
        changeRanking(tipo, index) {
            if (tipo === 'subir') {
                this.swapRanking(index, index - 1);
            } else if (tipo === 'bajar') {
                this.swapRanking(index, index + 1);
            }
        },
        deleteFavorite() {
            studentsService.deleteCareerPreference(
                this.$store.getters['authentication/student_uuid'],
                this.uuidToDelete,
            ).then(() => {
                this.$store.commit('authentication/removeStar');
                this.modalDelete = false;
                this.getData();
            });
        },
        dragHandler() {
            studentsService.patchCareerPreferenceRanks(
                this.$store.getters['authentication/student_uuid'],
                { careers: this.careers.map(c => c.career_id) },
            );
            this.$store.dispatch('clippyNotifications/addDirectMessage', 'UPDATE_RANKING');
        },
        getData() {
            this.loading_data = true;
            studentsService.getCareerPreferences(
                this.$store.getters['authentication/student_uuid'],
            ).then((response) => {
                this.careers = response.data;
                // Mark visit favorites tab
                this.$store.dispatch('clippyNotifications/visitFavorites', this.careers.length);
            }).finally(() => {
                this.loading_data = false;
            });
        },
        openModalDeleteFavorite(uuid) {
            const { modalDelete } = this;
            this.modalDelete = !modalDelete;
            this.uuidToDelete = uuid;
        },
        shareSummary() {
            this.sendingMail = true;
            this.blockMailButton = true;
            studentsService.getSendFavorites(
                this.$store.getters['authentication/student_uuid'],
            ).then(() => {
                this.sentMailModal = true;
                this.sendingMail = false;
            });
        },
        swapRanking(i1, i2) {
            const tempCareers = this.careers;
            const index1 = parseInt(i1, 10);
            const index2 = parseInt(i2, 10);

            const tempCareer = tempCareers[index1];
            tempCareers[index1] = tempCareers[index2];
            tempCareers[index2] = tempCareer;
            this.careers = tempCareers.slice();
            this.careersByRanking = tempCareers.slice();
            studentsService.patchCareerPreferenceRanks(
                this.$store.getters['authentication/student_uuid'],
                { careers: this.careers.map(c => c.career_id) },
            );
            this.$store.dispatch('clippyNotifications/addDirectMessage', 'UPDATE_RANKING');
        },
        downloadSummary() {
            window.open(`${CONFIG.API_ROOT}/students/pdf/${this.$store.getters['authentication/student_uuid']}?t=${this.$store.getters['authentication/token']}`,
                '_blank');
        },
        closeSentModal() {
            this.sentMailModal = false;
            this.blockMailButton = false;
        },
    },

};
</script>


<style lang="scss">
  .overlay_class {
    position: relative;
    z-index: 99999;

      &--active {
        opacity: 1;
      }
  }
  #overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 9999;
    pointer-events: none;
    opacity: 0;
    transition: opacity .3s ease;
  }


  .centerLoading {
    display: flex!important;
    align-items: center!important;
    justify-content: center!important;
  }
  .text-align-center {
    text-align: center;
  }
  .header-favorites {
    background-color: #f7f8fc;box-shadow: none; padding-top: 0px; padding-bottom: 0px !important;
  }
  .header-favorites-stuff {
    border-right: none; padding-top: 0px; padding-bottom: 0px;
  }
  .zindexStyle{
    z-index: 9999;
  }
</style>
